import { useOutletContext } from 'react-router-dom';
import InvoiceDisplayModeSelect from 'components/invoiceList/InvoiceDisplayModeSelect';
import InvoiceMonthList from 'components/invoiceList/InvoiceMonthList';
import InvoiceSelectionBar from 'components/invoiceList/InvoiceSelectionBar';

const InvoiceContent = () => {
  const {
    monthInvoices,
    onImportInvoices,
    onClearInvoiceFilters,
    invoiceDisplay,
    period,
    invoiceSelection,
    onRetryInvoices,
    isInvoiceImportRunning,
  } = useOutletContext();

  // The selection bar floats over the bottom of the list. The display choice
  // stays above it whatever the list shows: empty, failed or loading.
  return (
    <div className="relative flex flex-col flex-1 min-h-0">
      <div className="flex-shrink-0 pb-3">
        <InvoiceDisplayModeSelect {...invoiceDisplay} />
      </div>
      <InvoiceMonthList
        {...monthInvoices}
        period={period}
        onImport={onImportInvoices}
        onClearFilters={onClearInvoiceFilters}
        selection={invoiceSelection}
      />
      <InvoiceSelectionBar
        period={period}
        numbers={invoiceSelection.numbers}
        errorNumbers={invoiceSelection.errorNumbers}
        statuses={invoiceSelection.statuses}
        onRetry={onRetryInvoices}
        isImportRunning={isInvoiceImportRunning}
      />
    </div>
  );
};

export default InvoiceContent;
